import script from "./score-menu.vue?vue&type=script&setup=true&lang=ts"
export * from "./score-menu.vue?vue&type=script&setup=true&lang=ts"

import "./score-menu.vue?vue&type=style&index=0&id=16f11618&lang=scss"

const __exports__ = script;

export default __exports__